import React from "react";
import AdjustHandle from "../../Misc/AdjustHandle";
import { Icon } from "semantic-ui-react";

export default function CollapsibleSidebarLayoutView({
  sidebar,
  main,
  mouse,
  wrapperClasses,
  isCollapsed,
  sidebarRef,
  initialSidebarWidth,
  lastSidebarWidth,
  icon,
  label,
  isInverse,
}) {
  return (
    <div
      className={`collapsible-sidebar-container ${
        wrapperClasses ? wrapperClasses : ""
      } ${isInverse ? "inverse" : ""}`}
      onMouseMove={mouse.move}
      onMouseUp={mouse.up}
      onMouseLeave={mouse.up}
    >
      {isInverse ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              flex: 1,
              alignItems: "stretch",
            }}
            className="c-main screen-wrap"
          >
            {main}
          </div>
          {sidebar ? (
            <div
              className={`c-sidebar ${
                isCollapsed?.val ? "collapsed" : "expanded"
              }`}
              style={{
                width: lastSidebarWidth
                  ? lastSidebarWidth
                  : initialSidebarWidth ?? 325,
              }}
              ref={sidebarRef}
            >
              {sidebar}

              <AdjustHandle
                isCollapsed={isCollapsed}
                toggleResize={mouse?.down}
              />

              {isCollapsed.val && (
                <>
                  <button
                    className="expand"
                    onClick={() => isCollapsed.set(false)}
                  >
                    <span>
                      <Icon name={icon} />
                    </span>

                    {label && <span className="v-text">{label}</span>}
                  </button>
                </>
              )}
            </div>
          ) : null}
        </>
      ) : (
        <>
          {sidebar ? (
            <div
              className={`c-sidebar ${
                isCollapsed?.val ? "collapsed" : "expanded"
              }`}
              style={{
                width: lastSidebarWidth
                  ? lastSidebarWidth
                  : initialSidebarWidth ?? 325,
              }}
              ref={sidebarRef}
            >
              {sidebar}

              <AdjustHandle
                isCollapsed={isCollapsed}
                toggleResize={mouse?.down}
              />

              {isCollapsed.val && (
                <>
                  <button
                    className="expand"
                    onClick={() => isCollapsed.set(false)}
                  >
                    <span>
                      <Icon name={icon} />
                    </span>

                    {label && <span className="v-text">{label}</span>}
                  </button>
                </>
              )}
            </div>
          ) : null}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              flex: 1,
              alignItems: "stretch",
            }}
            className="c-main screen-wrap"
          >
            {main}
          </div>
        </>
      )}
    </div>
  );
}
